'use strict';

(function (angular) {
  angular.module('zp').directive('socialLinks', socialLinksDirective);

  /**@ngInject */
  function socialLinksDirective() {
    return {
      restrict: 'E',
      link: link,
      scope: scope
    };
  }
})(window.angular);